import { render, staticRenderFns } from "./websocketConference.vue?vue&type=template&id=af7b000a&scoped=true&"
import script from "./websocketConference.vue?vue&type=script&lang=js&"
export * from "./websocketConference.vue?vue&type=script&lang=js&"
import style0 from "./websocketConference.vue?vue&type=style&index=0&id=af7b000a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b000a",
  null
  
)

export default component.exports